import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import "../../Pages/Admin/Style.css";
import "./add_customer.css";
import { addUser } from "../../Api/apiUrls";

function Add_customer({ onClose }) {
  const [modalAdd_customerIsOpen, setAdd_customerModalIsOpen] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [isAddingcustomer, setIsAddingcustomer] = useState(false);

  const closeAdd_customer = () => {
    setAdd_customerModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsAddingcustomer(true);
  
    // Create form data object
    const formData = {
      name: name.trim(),
      email: email.trim(),
      mobileNumber: mobile.trim(),
      type_of_user: 'User',
      // Add any other required fields here
    };
  
    // Basic validation
    if (!formData.name || !formData.email || !formData.mobileNumber) {
      alert('Please fill in all required fields');
      setIsAddingcustomer(false);
      return;
    }
  
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      setIsAddingcustomer(false);
      return;
    }
  
    // Validate mobile number (basic check for 10 digits)
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(formData.mobileNumber)) {
      console.log(formData.mobileNumber);
      alert('Please enter a valid 10-digit mobile number');
      // setIsAddingcustomer(false);
      return;
    }
  
    try {
      const response = await fetch(addUser, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Add any authorization headers if needed
          // 'Authorization': `Bearer ${yourAuthToken}`,
        },
        body: JSON.stringify(formData),
      });
  
      const data = await response.json();

      alert(data.message);
      onClose();
      // If successful
      
      // Optional: reload or update state instead of full page reload
      window.location.reload();
    } catch (error) {
      console.error('Error adding customer:', error);
      alert(`Error: ${error.message}`);
    } finally {
      setIsAddingcustomer(false);
    }
  };

  return (
    <div>
      {modalAdd_customerIsOpen && <add_customer onClose={closeAdd_customer} />}
      <div className="popup-background">
        <div className="popup">
          <div
            className="modal-content"
            style={{
              width: "100%",
              height: "auto",
              padding: "2%",
              backgroundColor: "#fff",
              borderRadius: "5px",
            }}
          >
            <div
              className="modal-header"
              style={{
                width: "100%",
                marginBottom: "3%",
                borderBottom: "solid 1px #7e7a7a8c",
              }}
            >
              <h5
                className="modal-title"
                id="modalAddTitle"
                style={{ marginBottom: "2%" }}
              >
                <b>Add Customer</b>
              </h5>
            </div>

            <div
              className="modal-body"
              style={{ overflowY: "none", padding: "2%" }}
            >
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputName">
                    Name<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputName"
                    type="text"
                    placeholder="Enter Name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputEmail">
                    Email<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputEmail"
                    type="email"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="small mb-1" htmlFor="inputMobile">
                    Mobile Number<font color="red">*</font>
                  </label>
                  <input
                    className="form-control"
                    id="inputMobile"
                    type="tel"
                    placeholder="Enter Mobile Number"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                  />
                </div>

                <div
                  className="modal-footer"
                  style={{
                    padding: "2%",
                    marginTop: "3%",
                    borderTop: "solid 1px #7e7a7a8c",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Close
                  </button>
                  {isAddingcustomer ? (
                    <div>
                      <ThreeDots color="#000" height={50} width={50} />
                    </div>
                  ) : (
                    <button
                      id="btnAdd"
                      type="submit"
                      className="btn btn-primary "
                      style={{ background: "black ", border: "none" }}
                    >
                      Add
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Add_customer;